import React, { useState } from "react";
// import { userDataAtom } from "../config/globalStates";
import { useNavigate } from "react-router-dom";
// import CuInput from "../components/CuInput";
// import CuButton from "../components/CuButton";
import { toast } from "react-toastify";
// import { useCreateItem } from "../apis/mutations";
import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { useTranslation } from "react-i18next";
import { useAtom } from "jotai";
import { userDataAtom } from "../user/User-Detail/user-details-tab/UserDetailsAtom";
import { useCreateItem } from "../../_helper/actions/mutation/items";
import CuInput from "../../all-patient/components/CuInput";
import CuButton from "../../all-patient/components/CuButton";

const ManagePassword = () => {
  // const sm = !useMediaQuery({ query: "(min-width:768px)" });
  // const { t } = useTranslation();
  const [userData] = useAtom(userDataAtom);
  const navigate = useNavigate();
  // const filteredParentData = userData.filter(
  //     (user) => user?.is_parent === true && user?.family_id === user?.phone
  // );

  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const [errors, setErrors] = useState({});
  const [showPasswords, setShowPasswords] = useState({
    old_password: false,
    new_password: false,
    confirm_password: false,
  });

  const postChangePassword = useCreateItem("change/");

  const validate = () => {
    const newErrors = {};
    if (!formData.old_password)
      newErrors.old_password = "Current Password is required";
    if (!formData.new_password)
      newErrors.new_password = "New Password is required";
    else if (formData.new_password.length < 6)
      newErrors.new_password = "New Password must be at least 6 characters";
    if (!formData.confirm_password)
      newErrors.confirm_password = "Confirm Password is required";
    else if (formData.confirm_password.length < 6)
      newErrors.confirm_password =
        "Confirm Password must be at least 6 characters";
    if (formData.new_password !== formData.confirm_password)
      newErrors.confirm_password = "Passwords do not match";
    return newErrors;
  };

  const handleChange = (e, name) => {
    const { value } = e.target;
    if (value.includes(" ")) return;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear the specific error for the field being updated
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleTogglePasswordVisibility = (field) => {
    setShowPasswords((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSubmit = () => {
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    const payload = {
      action: "change_password",
      ...formData,
    };
    postChangePassword.mutate(payload, {
      onSuccess: (data) => {
        toast.success("Password changed successfully");
      },
      onError: (err) => {
        toast.error(err?.response?.data?.message);
      },
    });
  };

  return (
    <div className="min-[800px]:flex min-[800px]:gap-10 relative">
      <div className="min-[800px]:flex-1">
        <div className="mt-7 w-3/4 max-[1360px]:w-full px-4 lg:px-1 max-[800px]:grid-cols-2 max-[800px]:gap-2 max-[460px]:grid-cols-1 lg:gap-2">
          <div className="relative">
            <CuInput
              label="Current Password"
              placeholder="Current Password"
              type={showPasswords.old_password ? "text" : "password"}
              required
              value={formData.old_password}
              onChange={(e) => handleChange(e, "old_password")}
            />
            {errors.old_password && (
              <span className="text-red-500 text-xs">
                {errors.old_password}
              </span>
            )}
            <div
              className="absolute right-6 top-8 cursor-pointer"
              onClick={() => handleTogglePasswordVisibility("old_password")}
            >
              {showPasswords.old_password ? (
                <FaEye size={20} color="gray" />
              ) : (
                <FaEyeSlash size={20} color="gray" />
              )}
            </div>
          </div>
          <div className="relative">
            <CuInput
              label="New Password"
              placeholder="New Password"
              type={showPasswords.new_password ? "text" : "password"}
              required
              value={formData.new_password}
              onChange={(e) => handleChange(e, "new_password")}
            />
            {errors.new_password && (
              <span className="text-red-500 text-xs">
                {errors.new_password}
              </span>
            )}
            <div
              className="absolute right-6 top-8 cursor-pointer"
              onClick={() => handleTogglePasswordVisibility("new_password")}
            >
              {showPasswords.new_password ? (
                <FaEye size={20} color="gray" />
              ) : (
                <FaEyeSlash size={20} color="gray" />
              )}
            </div>
          </div>
          <div className="relative">
            <CuInput
              label="Confirm New Password"
              placeholder="Confirm New Password"
              type={showPasswords.confirm_password ? "text" : "password"}
              required
              value={formData.confirm_password}
              onChange={(e) => handleChange(e, "confirm_password")}
            />
            {errors.confirm_password && (
              <span className="text-red-500 text-xs">
                {errors.confirm_password}
              </span>
            )}
            <div
              className="absolute right-6 top-8 cursor-pointer"
              onClick={() => handleTogglePasswordVisibility("confirm_password")}
            >
              {showPasswords.confirm_password ? (
                <FaEye size={20} color="gray" />
              ) : (
                <FaEyeSlash size={20} color="gray" />
              )}
            </div>
          </div>
        </div>
        <div className="w-3/4 mt-7 max-[1360px]:w-full grid lg:grid-cols-auto-fit lg:grid-cols-2 max-[1024px]:grid-cols-1 max-[800px]:grid-cols-2 max-[800px]:gap-2 max-[460px]:grid-cols-1 px-4 lg:px-1 lg:gap-2">
          <div className="w-full flex gap-4">
            <CuButton
              className="h-[50px] flex-1 rounded-[5px] border border-[#00000033]"
              onClick={() => navigate(-1)}
            >
              Cancel
            </CuButton>
            <CuButton
              className="h-[50px] flex-1 rounded-[5px] border border-[#00000033] bg-[#C7EAC9]"
              onClick={handleSubmit}
              isLoading={postChangePassword.isLoading}
            >
              Submit
            </CuButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagePassword;
